export enum LocaleEnum {
  DE = 'de',
  EN = 'en',
  IT = 'it',
  BG = 'bg',
  FR = 'fr',
  RSI = 'rsi',
  GOLFMEISTERSCHAFT = 'golfmeisterschaft',
  INT = 'int',
}

export type Locale = `${LocaleEnum}`;

export const isLocale = (value: string): value is LocaleEnum => {
  return Object.values(LocaleEnum).includes(value as LocaleEnum);
};
